import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class DcSpinnerService {
  event = new EventEmitter();

  start() {
    this.event.emit(true);
  }

  stop() {
    this.event.emit(false);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/services/spinner.service.ts